import { render, staticRenderFns } from "./LessonPDFButton.vue?vue&type=template&id=4e800b8e&"
import script from "./LessonPDFButton.vue?vue&type=script&lang=js&"
export * from "./LessonPDFButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports